module.exports = __webpack_public_path__ + "assets/ic_tree25.c76f7bf3.svg";